import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountTypesHeading: {
    defaultMessage: 'Connection type',
    id: 'accessTypes.accountTypesHeading',
  },
  accountTypesDescription: {
    defaultMessage:
      'Due to EU regulations, different account types need to be connected separately.',
    id: 'accessTypes.accountTypesDescription',
  },
  addAccountsHeading: {
    defaultMessage: 'Add {providerName} accounts',
    id: 'accessTypes.addAccounts',
  },
  addAccountAction: {
    defaultMessage: 'Add',
    id: 'accessTypes.addAccountAction',
  },
  openBankingAccessTypeTitle: {
    defaultMessage: 'Checking accounts',
    id: 'accessTypes.openBankingAccessTypeTitle',
  },
  openBankingAccessTypeBody: {
    defaultMessage: 'Including everyday accounts, such as your salary account',
    id: 'accessTypes.openBankingAccessTypeBody',
  },
  otherAccessTypeTitle: {
    defaultMessage: 'Other account types',
    id: 'accessTypes.otherAccessTypeTitle',
  },
  otherAccessTypeBody: {
    defaultMessage:
      'Including saving accounts, credit cards, loans, investments and personal information',
    id: 'accessTypes.otherAccessTypeBody',
  },
  capabilityUnknown: {
    defaultMessage: 'Unknown',
    id: 'accessTypes.capabilityUnknown',
  },
  capabilityCheckingAccounts: {
    defaultMessage: 'Current accounts',
    id: 'accessTypes.capabilityCheckingAccounts',
  },
  capabilitySavingsAccounts: {
    defaultMessage: 'Savings accounts',
    id: 'accessTypes.capabilitySavingsAccounts',
  },
  capabilityCreditCards: {
    defaultMessage: 'Credit cards',
    id: 'accessTypes.capabilityCreditCards',
  },
  capabilityInvestments: {
    defaultMessage: 'Investments',
    id: 'accessTypes.capabilityInvestments',
  },
  capabilityLoans: {
    defaultMessage: 'Loans',
    id: 'accessTypes.capabilityLoans',
  },
  capabilityMortgageLoan: {
    defaultMessage: 'Mortgage loan',
    id: 'accessTypes.capabilityMortgageLoan',
  },
  capabilityIdentityData: {
    defaultMessage: 'Identity information',
    id: 'accessTypes.capabilityIdentityData',
  },
  capabilityEinvoices: {
    defaultMessage: 'E-invoices',
    id: 'accessTypes.capabilityEinvoices',
  },
  accessTypeHeaderOpenBanking: {
    defaultMessage: 'Open banking',
    id: 'accessTypes.accessTypeHeaderOpenBanking',
  },
  accessTypeHeaderOther: {
    defaultMessage: 'Other',
    id: 'accessTypes.accessTypeHeaderOther',
  },
});
